export default function SegmentationMarker() {
	return <div className="segmentation-marker"></div>
}
